export const SAVE_DRAFT_SUCCESS =
    "Successfully saved as draft - you can leave and come back to this later!"

export const TTR_DIALOG_MESSAGE =
    "This database enables logged in manufacturer users to enter details and upload documents for devices that prove compliance to the latest standards. The data entered and uploaded documents are available for users to browse and view. The ENA simply hosts manufacturers' data and their statements of compliance on behalf of its Distribution Network Operator (DNO) members in order to promote product identification and information sharing."

export const DRAFT_INFO_BANNER =
    "Drafts will be automatically deleted 6 months after the date they were last updated. Please submit your application before this time."
